import { createSlice } from '@reduxjs/toolkit';

import { signOut } from '../authentication/authentication-actions';
import { clearCart } from '../select-tickets/cart-reducer';
import { AssignedTickets } from './assign-tickets';
import {
  setSelfAssignedTicket,
  storeAssignedTickets,
} from './assign-tickets-actions';

export interface AssignTicketsState {
  tickets: AssignedTickets;
  selfAssignedTicketFieldsetId: Nullable<string>;
}

export const initialState: AssignTicketsState = {
  tickets: [],
  selfAssignedTicketFieldsetId: null,
};

const assignTicketsSlice = createSlice({
  name: 'assignTickets',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(clearCart, () => {
        return { ...initialState };
      })
      .addCase(signOut, () => {
        return { ...initialState };
      })
      .addCase(storeAssignedTickets, (state, { payload }) => {
        state.tickets = payload;
      })
      .addCase(setSelfAssignedTicket, (state, { payload }) => {
        state.selfAssignedTicketFieldsetId = payload;
      });
  },
});

export const { reducer } = assignTicketsSlice;
